import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import { computed, type HTMLAttributes } from 'vue';
import {
  DialogPortal,
  DialogOverlay,
  DialogContent,
  DialogClose,
  useForwardPropsEmits,
  type DialogContentProps,
  type DialogContentEmits,
} from 'reka-ui';
import { X } from '@lucide/vue';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'SheetContent',
  props: {
    forceMount: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {},
    side: { default: 'right' },
    showClose: { type: Boolean, default: true }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const forwarded = useForwardPropsEmits(
  computed(() => {
    const { class: _class, side: _side, showClose: _showClose, ...rest } = props;
    return rest;
  }),
  emit
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogPortal), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 z-50 bg-slate-950/35 backdrop-blur-[1px] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0" }),
      _createVNode(_unref(DialogContent), _mergeProps(_unref(forwarded), {
        class: 
        _unref(cn)(
          'fixed inset-y-0 z-50 flex h-dvh w-full max-w-lg flex-col gap-5 overflow-y-auto border bg-card p-6 shadow-[0_12px_48px_rgba(15,23,42,0.16)] duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out',
          __props.side === 'right'
            ? 'right-0 border-l data-[state=open]:slide-in-from-right data-[state=closed]:slide-out-to-right'
            : 'left-0 border-r data-[state=open]:slide-in-from-left data-[state=closed]:slide-out-to-left',
          props.class
        )
      
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default"),
          (__props.showClose)
            ? (_openBlock(), _createBlock(_unref(DialogClose), {
                key: 0,
                class: "absolute right-4 top-4 rounded-sm p-1 text-muted-foreground opacity-75 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-ring/30",
                "aria-label": "Закрыть"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(X), { class: "size-4" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["class"])
    ]),
    _: 3
  }))
}
}

})